import {
  Accordion,
  Button,
  Text,
  Title,
  Table,
  Select,
  Group,
} from "@mantine/core";
import React, { useState, useEffect } from "react";
import moment from "moment";
import { useServerApi } from "../hooks/userServerApi";
import { DatePicker } from "@mantine/dates";
import { useTranslation } from "react-i18next";
import _ from "lodash";
import RemoteSelect2 from "./remoteSelect2";
import { openFileUrl } from "../utils/openReport";

const ReportGIOutStandingPayment = ({}) => {
  const [loading, setLoading] = useState(false);
  const [consultant, setConsultant] = useState();
  const [api] = useServerApi();
  const { t } = useTranslation();

  const downloadReport = async () => {
    try {
      setLoading(true);

      // console.log(fromDate, toDate);

      const result = await api.DebitNote.getOutStandingPaymentReport({
        consultant,
      });
      setLoading(false);
      // console.log(result);
      if (result && result.data && result.data.url) {
        await openFileUrl(result.data.url);
      }
    } catch (error) {
      setLoading(false);
      // console.log(error);
    }
  };

  return (
    <div>
      <Text size="xs" mb="xl">
        {t(
          "Please click the below button to download the outstanding payment report."
        )}
      </Text>
      <RemoteSelect2
        title="Consultant"
        size="xs"
        allowFreeInput
        placeholder="Select Consultant (Empty for all)"
        onDataChange={(d) => {
          if (d) {
            setConsultant(d._id);
          } else {
            setConsultant(null);
          }
        }}
        apiEntity="user"
        valueField="_id"
        labelField="name"
        labelRender={(data) =>
          `[${data.staffId}] ${data.name} ${
            data.aliasName ? `(${data.aliasName})` : ""
          }`
        }
        searchFields={["name", "staffId", "aliasName"]}
        clearable
        multiple={false}
        style={{ width: "350px" }}
        pageSize={100}
      />
      <Button
        size="xs"
        mt="xl"
        onClick={() => downloadReport()}
        loading={loading}
      >
        {t("Download")}
      </Button>
      <></>
    </div>
  );
};

export default ReportGIOutStandingPayment;
